export default __webpack_public_path__ + "322071dd76ca3415fe586ed465a6ce5f.png";